// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8730f2bd888b5bb268f5","655":"a3ee8690772148d07491"}[chunkId] + ".js";
};